import { AuthError } from '@juvare/platform-app/App';
import { defineClassifierEntity, transformClassifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers';
import { classifierColumns } from '@juvare/platform-sdk-react/backend/features/classifiers/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
import { trainCourseSchema } from '../types';
export const trainCourseColumns = defineColumns(Object.assign(Object.assign({}, classifierColumns), { trainId: {
        type: 'number-required',
        index: 'unique',
    }, name: {
        type: 'string-required',
    } }));
export const trainCourseEntityName = 'trainCourse';
export function defineTrainCourseClassifier() {
    return defineClassifierEntity({
        entity: {
            version: 2,
            columns: trainCourseColumns,
            onTransformColumns: (_, params) => (Object.assign(Object.assign({}, transformClassifierColumns(params)), { trainId: params.data.trainId })),
            onMigrate: (params) => params.oldData,
            onAuthPost: () => {
                // write is not allowed cause list is being synchronized by jas TRAIN integration
                throw new AuthError('Unauthorized');
            },
        },
    }, trainCourseSchema);
}
